import React, { useState, useEffect } from "react";

import Box from "@mui/material/Box";
import { DataGrid, GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";

import {
  Grid,
  Paper,
  Typography,
  Button,
  TextField,
  Autocomplete,
} from "@mui/material";

import axios from "../../../../api/axios";

const URL = "./claim/report/dealership";

function DealershipClaimReport() {
  const [dealershipList, setDealershipList] = useState([]);

  const [dealership, setDealership] = useState(null);

  const [rows, setRows] = useState([]);

  const [totalRequested, setTotalRequested] = useState(0);

  const [totalPaid, setTotalPaid] = useState(0);

  useEffect(() => {
    loadDealerships();
  }, []);

  const loadDealerships = async () => {
    try {
      const response = await axios.post("./claim/getClaimDealerships");

      setDealershipList(response.data.data);
    } catch (err) {
      console.log(err);
    }
  };

  const searchReport = async () => {
    if (!dealership) {
      alert("Please Select Dealership");

      return;
    }

    try {
      const response = await axios.post(URL, {
        dealership: dealership.id,
      });

      setRows(response.data.data);

      setTotalRequested(response.data.totalRequestedClaimAmount || 0);

      setTotalPaid(response.data.totalPaidClaimAmount || 0);
    } catch (err) {
      console.log(err);
    }
  };


  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarExport
          csvOptions={{
            fileName: "vehicle_warranty",
            utf8WithBom: true,
          }}
          printOptions={{
            disableToolbarButton: true,
          }}
        />
      </GridToolbarContainer>
    );
  }

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 80,
    },

    {
      field: "vinNo",
      headerName: "VIN",
      width: 180,
    },

    {
      field: "customerFirstName",
      headerName: "First Name",
      width: 150,
    },

    {
      field: "customerLastName",
      headerName: "Last Name",
      width: 150,
    },

    {
      field: "make",
      headerName: "Make",
      width: 120,
    },

    {
      field: "model",
      headerName: "Model",
      width: 120,
    },

    {
      field: "dealership",
      headerName: "Dealership",
      width: 220,
    },

    {
      field: "requestedClaimAmount",
      headerName: "Requested Claim",
      width: 170,
      renderCell: (params) => `$${params.value ?? 0}`,
    },

    {
      field: "paidClaimAmount",
      headerName: "Paid Claim",
      width: 170,
      renderCell: (params) => `$${params.value ?? 0}`,
    },
  ];
  return (
    <Box sx={{ marginTop: "150px" }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>
          Dealership Claim Report
        </Typography>

        <Grid container spacing={2} alignItems="center">
          <Grid item xs={6}>
            <Autocomplete
              options={dealershipList}
              value={dealership}
              onChange={(event, value) => setDealership(value)}
              getOptionLabel={(option) => option.accountName || ""}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField {...params} label="Select Dealership" />
              )}
            />
          </Grid>

          <Grid item xs={2}>
            <Button
              fullWidth
              variant="contained"
              sx={{ height: 55 }}
              onClick={searchReport}
            >
              Search
            </Button>
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item xs={3}>
            <Paper
              elevation={3}
              sx={{
                p: 2,
                textAlign: "center",
              }}
            >
              <Typography variant="subtitle2">Total Requested Claim</Typography>

              <Typography variant="h5" color="primary">
                ${totalRequested.toFixed(2)}
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={3}>
            <Paper
              elevation={3}
              sx={{
                p: 2,
                textAlign: "center",
              }}
            >
              <Typography variant="subtitle2">Total Paid Claim</Typography>

              <Typography variant="h5" color="success.main">
                ${totalPaid.toFixed(2)}
              </Typography>
            </Paper>
          </Grid>
        </Grid>

        <Box sx={{ mt: 3 }}>
          <DataGrid
            rows={rows}
            columns={columns}
            autoHeight
            pageSizeOptions={[10, 25, 50, 100]}
            pagination
            initialState={{
              pagination: {
                paginationModel: {
                  page: 0,

                  pageSize: 25,
                },
              },
            }}
            slots={{
              toolbar: CustomToolbar,
            }}
            sx={{
              "& .MuiDataGrid-columnHeaderTitle": {
                fontWeight: "bold",
              },
            }}
          />
        </Box>
      </Paper>
    </Box>
  );
}

export default DealershipClaimReport;
